export const sidebar = "sidebar";
export const headerOnly = "header-only";
export const admin = "admin";
export const auto = "auto";
